module.exports = require('./assignIn');



//////////////////
// WEBPACK FOOTER
// /home/travis/build/Kinvey/js-sdk/node_modules/lodash/extend.js
// module id = 442
// module chunks = 0